import ExpServiceProvider from '../../expr/api';

export const indexReplacement = (idxVar: string): string =>
  ExpServiceProvider.getExpressionBuilder().indexReplacement(idxVar);
